import { useState } from "react";

import { columns } from "./Table/components/columns";
import { DataTable } from "./Table/components/data-table";

type Props = {};

const Main = () => {
  const [tableData, settableData] = useState([]);

  return (
    <div>
      <DataTable data={tableData || []} columns={columns} />
    </div>
  );
};

const ReferredRewardsTable = (props: Props) => {
  return (
    <div className="space-y-2">
      <div className="text-primary uppercase font-semibold">Referred Rewards</div>
      <Main />
    </div>
  );
};

export default ReferredRewardsTable;
